import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "0 0 40 40",
  class: "rocket_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m4.083 17.625 7-7a3.338 3.338 0 0 1 1.375-.833 3.217 3.217 0 0 1 1.625-.084l2.167.459c-1.5 1.777-2.68 3.389-3.542 4.833-.86 1.445-1.694 3.195-2.5 5.25l-6.125-2.625Zm8.542 3.792a25.55 25.55 0 0 1 2.604-5.667 27.477 27.477 0 0 1 3.98-5c2.444-2.444 5.235-4.27 8.374-5.48 3.14-1.207 6.07-1.576 8.792-1.103.472 2.722.111 5.652-1.083 8.791-1.195 3.14-3.014 5.93-5.459 8.375a27.974 27.974 0 0 1-5 3.98 25.336 25.336 0 0 1-5.708 2.645l-6.5-6.541Zm11.5-5c.639.639 1.424.958 2.354.958.93 0 1.715-.32 2.354-.958.64-.64.959-1.424.959-2.355 0-.93-.32-1.715-.959-2.354s-1.423-.958-2.354-.958c-.93 0-1.715.32-2.354.958-.639.64-.958 1.424-.958 2.354 0 .931.32 1.716.958 2.355Zm-1.167 20.041-2.666-6.125c2.055-.805 3.812-1.638 5.27-2.5 1.459-.86 3.077-2.041 4.855-3.541l.416 2.166a3.307 3.307 0 0 1-.083 1.646 3.324 3.324 0 0 1-.833 1.396l-6.959 6.958ZM6.75 26.75c.972-.972 2.153-1.465 3.542-1.48 1.389-.013 2.57.466 3.541 1.438.973.973 1.459 2.153 1.459 3.542 0 1.389-.486 2.57-1.459 3.542-.694.694-1.854 1.291-3.479 1.791s-3.868.945-6.729 1.334c.389-2.861.833-5.098 1.333-6.709.5-1.61 1.098-2.763 1.792-3.458Z"
    }, null, -1)
  ]))]))
}
export default { render: render }